import './skeleton-shape.less';

export const CountSkeletonShape = (
    <div className="CountSkeletonShape">
        <div className="circle"></div>
    </div>
);
